import { FC } from 'react';

import IcDiscover from 'src/assets/images/icDiscover.svg';
import IcHistory from 'src/assets/images/icHistory.svg';
import IcMessage from 'src/assets/images/icMessageFill.svg';
import { Routes } from 'src/router/route';
import { Pathname } from 'src/router/types';

export const TAB_NAME = [
  'mirror',
  'about',
  'history',
  'history_modal',
  'blog',
  'message',
  'seo_landing',
  'download',
  'creator',
  'follow',
] as const;

export type TabName = (typeof TAB_NAME)[number];

export interface TabConfig {
  route: keyof typeof Routes;
  pathnames: Pathname[];
  icon?: FC;
  label: string;
  name: TabName;
}

export const TAB_CONFIGS = [
  {
    route: '/',
    icon: IcDiscover,
    label: 'Video Chat',
    name: 'mirror',
    pathnames: ['/', '/[locale]'],
  },
  {
    route: '/history',
    icon: IcHistory,
    label: 'History',
    name: 'history',
    pathnames: ['/history', '/[locale]/history'],
  },
  {
    route: '/about',
    label: 'About',
    name: 'about',
    pathnames: ['/about', '/[locale]/about'],
  },
  {
    route: '/blog',
    label: 'Blog',
    name: 'blog',
    pathnames: [
      '/blog',
      '/blog/[sectionName]/[articleTitle]',
      '/[locale]/blog',
      '/[locale]/blog/[sectionName]/[articleTitle]',
    ],
  },
  {
    route: '/messages',
    icon: IcMessage,
    label: 'Messages',
    name: 'message',
    pathnames: ['/messages', '/messages/room'],
  },
  {
    route: '/download',
    label: 'Download',
    name: 'download',
    pathnames: ['/download'],
  },
  {
    route: '/creator-join',
    label: 'Creator Join',
    name: 'creator',
    pathnames: ['/creator-join'],
  },
  {
    route: '/creator-reward',
    label: 'Creator Reward',
    name: 'creator',
    pathnames: ['/creator-reward'],
  },
  {
    route: '/follow',
    label: 'Follow',
    name: 'follow',
    pathnames: ['/follow'],
  },
] satisfies TabConfig[];

/**
 * EventLog의 Tab 개념과 SelectTab API의 Tab개념이 다름
 * - EventLog = mirror / match를 구분하지 않음
 * - SelectTab API = mirror / match를 구분함
 *
 * 이 차이를 개선하는 고도화는 추후 진행
 * [WEB-3601:](https://hyperconnect.atlassian.net/browse/WEB-3601) 이벤트로그의 page/tab 최신화 및 모든 이벤트에 적용
 */
export interface SelectTabRequest {
  tabName:
    | 'MIRROR'
    | 'MATCH'
    | 'HISTORY'
    | 'HISTORY_MODAL'
    | 'ABOUT'
    | 'BLOG'
    | 'MESSAGE'
    | 'SEO_LANDING'
    | 'DOWNLOAD'
    | 'CREATOR'
    | 'FOLLOW';
}
